// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"356":"b8fee2c7","370":"63587647","852":"8f39bed8"}[chunkId] + ".chunk.css";
};